/* STOICINDEX · The 1-Day Reset — motor de la experiencia guiada (v26)
   Pantallas paso a paso + autosave en localStorage + velo oscuro (Anti-Vision)
   + .ics de recordatorios + Reset Card. Sin dependencias. */
(function () {
  'use strict';
  if (window.__stoicGuide) return;
  window.__stoicGuide = true;

  var root = document.querySelector('[data-stoic-guide]');
  if (!root) return;

  document.documentElement.classList.add('stoic-js');
  var KEY = 'stoic-reset-v1';

  /* ---------- Estado ---------- */
  var state = { i: 0, a: {} };
  var resumeTo = null; /* índice guardado al que saltar desde "Continue where I left off" */
  try {
    var raw = localStorage.getItem(KEY);
    if (raw) {
      var parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') {
        state.i = typeof parsed.i === 'number' ? parsed.i : 0;
        state.a = parsed.a && typeof parsed.a === 'object' ? parsed.a : {};
      }
    }
  } catch (e) { /* almacenamiento no disponible: la experiencia funciona sin guardar */ }

  function persist() {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) { /* sin almacenamiento */ }
  }

  function track(name) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'reset_' + name });
    } catch (e) { /* sin analítica */ }
  }

  /* ---------- Pantallas ---------- */
  var screens = Array.prototype.slice.call(root.querySelectorAll('[data-screen]'));
  var bar = root.querySelector('[data-guide-bar]');
  /* Si el estado guardó el NOMBRE de la pantalla, manda sobre el índice (las pantallas pueden reordenarse entre versiones) */
  if (state.n) {
    for (var sn = 0; sn < screens.length; sn++) {
      if (screens[sn].getAttribute('data-screen') === state.n) { state.i = sn; break; }
    }
  }
  if (state.i < 0 || state.i >= screens.length) state.i = 0;

  /* Contadores "n / total" por fase (solo pantallas con pregunta) */
  var phaseGroups = {};
  screens.forEach(function (s) {
    if (!s.hasAttribute('data-q')) return;
    var eyebrow = s.querySelector('.stoic-eyebrow');
    var phase = eyebrow ? eyebrow.textContent.split('·')[0] : 'q';
    if (!phaseGroups[phase]) phaseGroups[phase] = [];
    phaseGroups[phase].push(s);
  });
  Object.keys(phaseGroups).forEach(function (phase) {
    var group = phaseGroups[phase];
    group.forEach(function (s, idx) {
      var count = s.querySelector('[data-guide-count]');
      if (count) count.textContent = idx + 1 + ' / ' + group.length;
    });
  });

  function populateOutputs(screen) {
    screen.querySelectorAll('[data-guide-out]').forEach(function (el) {
      var v = (state.a[el.getAttribute('data-guide-out')] || '').trim();
      el.textContent = v !== '' ? v : '…';
    });
    var levers = screen.querySelector('[data-guide-levers]');
    if (levers) {
      var rows = [];
      ['1', '2', '3'].forEach(function (n) {
        var action = (state.a['l' + n + 'a'] || '').trim();
        if (action === '') return;
        var time = (state.a['l' + n + 't'] || '').trim();
        rows.push({ action: action, time: time });
      });
      levers.innerHTML = '';
      if (rows.length === 0) {
        var empty = document.createElement('li');
        empty.textContent = '…';
        levers.appendChild(empty);
      } else {
        rows.forEach(function (row) {
          var li = document.createElement('li');
          if (row.time) {
            var strong = document.createElement('strong');
            strong.textContent = row.time;
            li.appendChild(strong);
            li.appendChild(document.createTextNode(' · ' + row.action));
          } else {
            li.appendChild(document.createTextNode(row.action));
          }
          levers.appendChild(li);
        });
      }
    }
    var date = screen.querySelector('[data-guide-date]');
    if (date && date.textContent === '') {
      try {
        date.textContent = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
      } catch (e) { date.textContent = new Date().toDateString(); }
    }
    populateBridge(screen);
  }

  /* ---------- Puente 180-Day: personalizado + oferta de 72 h ---------- */
  var OFFER_KEY = 'stoic-reset-offer-ts';
  var OFFER_HOURS = 72;

  function offerStartedAt() {
    try { return parseInt(localStorage.getItem(OFFER_KEY), 10) || 0; } catch (e) { return 0; }
  }
  function startOffer() {
    if (offerStartedAt()) return;
    try { localStorage.setItem(OFFER_KEY, String(Date.now())); } catch (e) { /* sin almacenamiento */ }
  }
  function offerHoursLeft() {
    var ts = offerStartedAt();
    if (!ts) return OFFER_HOURS;
    return (ts + OFFER_HOURS * 3600000 - Date.now()) / 3600000;
  }
  function offerLeftLabel(hours) {
    if (hours >= 47) return Math.round(hours / 24) + ' days';
    if (hours >= 1.5) return Math.round(hours) + ' hours';
    if (hours > 0) return 'under an hour';
    return '';
  }

  function populateBridge(screen) {
    var bridge = screen.querySelector('[data-guide-bridge]');
    if (!bridge) return;
    /* El reloj arranca la primera vez que ven la card (cubre a quien terminó antes de este cambio) */
    startOffer();
    /* Sus dos frases, tal cual las escribió: anti-visión (avs) y visión (vs) */
    var avs = (state.a.avs || '').trim();
    var vs = (state.a.vs || '').trim();
    var lines = bridge.querySelector('[data-guide-bridge-lines]');
    var avsRow = bridge.querySelector('[data-guide-bridge-avs-row]');
    var vsRow = bridge.querySelector('[data-guide-bridge-vs-row]');
    var avsOut = bridge.querySelector('[data-guide-bridge-avs]');
    var vsOut = bridge.querySelector('[data-guide-bridge-vs]');
    if (avsOut) avsOut.textContent = avs;
    if (vsOut) vsOut.textContent = vs;
    if (avsRow) avsRow.hidden = avs === '';
    if (vsRow) vsRow.hidden = vs === '';
    if (lines) lines.hidden = avs === '' && vs === '';
    /* Hora de su primera palanca: mañana a esa hora empieza el Día 1 */
    var time = (state.a.l1t || state.a.l2t || state.a.l3t || '').trim();
    var day2 = bridge.querySelector('[data-guide-bridge-day2]');
    var timeOut = bridge.querySelector('[data-guide-bridge-time]');
    if (day2 && timeOut) {
      timeOut.textContent = time;
      day2.hidden = time === '';
    }
    /* Oferta: visible mientras queden horas; después, botón a precio normal */
    var left = offerHoursLeft();
    var offer = bridge.querySelector('[data-guide-offer]');
    var offerBtn = bridge.querySelector('[data-guide-t180-offer]');
    var plainBtn = bridge.querySelector('[data-guide-t180-plain]');
    var leftOut = bridge.querySelector('[data-guide-offer-left]');
    var live = left > 0;
    if (offer) offer.hidden = !live;
    if (offerBtn) offerBtn.hidden = !live;
    if (plainBtn) plainBtn.hidden = live;
    if (leftOut && live) leftOut.textContent = offerLeftLabel(left);
  }

  function copyCode(btn) {
    var code = btn.getAttribute('data-guide-copy-code') || '';
    var label = btn.querySelector('[data-guide-copy-label]');
    function done() {
      if (!label) return;
      label.textContent = 'Copied';
      setTimeout(function () { label.textContent = 'Copy'; }, 1800);
    }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else {
        var ta = document.createElement('textarea');
        ta.value = code;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        done();
      }
    } catch (e) { done(); }
    track('code_copy');
  }

  function populateFields(screen) {
    screen.querySelectorAll('[data-guide-field]').forEach(function (field) {
      var key = field.getAttribute('data-guide-field');
      if (field.type === 'checkbox') {
        field.checked = state.a[key] === true;
      } else if (state.a[key] !== undefined && field.value !== state.a[key]) {
        field.value = state.a[key];
      }
      if (field.tagName === 'TEXTAREA') autogrow(field);
    });
  }

  function show(i, focusHeading, skipPersist) {
    if (i < 0) i = 0;
    if (i >= screens.length) i = screens.length - 1;
    state.i = i;
    state.n = screens[i] ? screens[i].getAttribute('data-screen') : '';
    if (!skipPersist) persist();
    screens.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
    var screen = screens[i];
    populateFields(screen);
    populateOutputs(screen);
    document.documentElement.classList.toggle('stoic-guide-dark', screen.classList.contains('stoic-guide__screen--dark'));
    if (bar) bar.style.width = ((i / (screens.length - 1)) * 100).toFixed(1) + '%';
    window.scrollTo({ top: 0, behavior: 'auto' });
    if (focusHeading) {
      var h = screen.querySelector('h1, h2');
      if (h) {
        h.setAttribute('tabindex', '-1');
        h.focus({ preventScroll: true });
      }
    }
  }

  /* ---------- Autosave ---------- */
  var saveTimers = {};
  function saveField(field) {
    var key = field.getAttribute('data-guide-field');
    state.a[key] = field.type === 'checkbox' ? field.checked : field.value;
    persist();
    var wrap = field.closest('.stoic-guide__field');
    if (wrap && wrap.querySelector('.stoic-guide__saved')) {
      wrap.classList.add('is-saved');
      clearTimeout(saveTimers[key]);
      saveTimers[key] = setTimeout(function () { wrap.classList.remove('is-saved'); }, 1800);
    }
  }

  function autogrow(textarea) {
    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
  }

  root.addEventListener('input', function (e) {
    var field = e.target.closest('[data-guide-field]');
    if (!field) return;
    if (field.tagName === 'TEXTAREA') autogrow(field);
    saveField(field);
  });
  root.addEventListener('change', function (e) {
    var field = e.target.closest('[data-guide-field]');
    if (field) saveField(field);
  });

  /* Enter en campos de una línea = guardar y cerrar teclado (no avanza:
     casi todas estas pantallas tienen varios campos) */
  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var field = e.target.closest('input[type="text"], input[type="time"]');
    if (!field) return;
    e.preventDefault();
    field.blur();
  });

  /* ---------- Navegación e interacciones ---------- */
  root.addEventListener('click', function (e) {
    var next = e.target.closest('[data-guide-next]');
    var back = e.target.closest('[data-guide-back]');
    var reveal = e.target.closest('[data-guide-reveal]');
    var chip = e.target.closest('[data-guide-chip]');
    var ics = e.target.closest('[data-guide-ics]');
    var alarms = e.target.closest('[data-guide-alarms]');
    var restart = e.target.closest('[data-guide-restart]');
    var planner = e.target.closest('[data-guide-planner]');

    if (reveal && !reveal.classList.contains('is-revealed')) {
      reveal.classList.add('is-revealed');
      return;
    }
    if (chip) {
      var target = root.querySelector('[data-guide-field="' + chip.getAttribute('data-target') + '"]');
      if (target) {
        target.value = chip.textContent.trim();
        saveField(target);
      }
      chip.parentElement.querySelectorAll('.stoic-guide__chip').forEach(function (c) {
        c.classList.toggle('is-selected', c === chip);
      });
      return;
    }
    if (ics) {
      downloadICS();
      track('ics_download');
      return;
    }
    var ruleToggle = e.target.closest('[data-guide-rule-toggle]');
    if (ruleToggle) {
      var full = root.querySelector('[data-guide-rule-full]');
      if (full) {
        full.hidden = !full.hidden;
        ruleToggle.setAttribute('aria-expanded', full.hidden ? 'false' : 'true');
        ruleToggle.textContent = full.hidden ? 'Why it matters' : 'Got it';
      }
      return;
    }
    var copyBtn = e.target.closest('[data-guide-copy-code]');
    if (copyBtn) {
      copyCode(copyBtn);
      return;
    }
    var saveCard = e.target.closest('[data-guide-save-card]');
    if (saveCard) {
      saveCardImage();
      /* Si aún no dejó su email, acompañarle hasta el bloque de email;
         si ya lo dejó, hasta el puente 180 */
      var mail = root.querySelector('#StoicResetEmail');
      var target = (mail && !mail.classList.contains('is-posted')) ? mail : root.querySelector('[data-guide-bridge]');
      if (target) {
        setTimeout(function () {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          target.classList.remove('is-nudged');
          void target.offsetWidth; /* reinicia la animación */
          target.classList.add('is-nudged');
        }, 900);
      }
      return;
    }
    if (alarms) {
      var list = root.querySelector('[data-guide-alarm-list]');
      if (list) list.hidden = !list.hidden;
      return;
    }
    if (restart) {
      if (window.confirm('Erase all your answers from this device and start a new reset?')) {
        state = { i: 0, a: {} };
        resumeTo = null;
        persist();
        try { localStorage.removeItem(OFFER_KEY); } catch (err) { /* sin almacenamiento */ }
        root.querySelectorAll('[data-guide-field]').forEach(function (f) {
          if (f.type === 'checkbox') f.checked = false;
          else f.value = '';
        });
        root.querySelectorAll('.is-revealed').forEach(function (r) { r.classList.remove('is-revealed'); });
        updateStartLabel();
        show(0, true);
        track('restart');
      }
      return;
    }
    if (planner) track('planner_click');
    var t180 = e.target.closest('[data-guide-t180]');
    if (t180) track('t180_click');
    if (next) {
      /* "Continue where I left off": saltar al punto guardado */
      if (next.hasAttribute('data-guide-start') && resumeTo !== null) {
        var to = resumeTo;
        resumeTo = null;
        track('resume');
        show(to, true);
        return;
      }
      /* Aviso suave si llegan a la fase de la tarde demasiado pronto */
      if (next.hasAttribute('data-guide-evening-gate')) {
        var hour = new Date().getHours();
        var note = root.querySelector('[data-guide-early-note]');
        if (hour < 19 && note && note.hidden) {
          note.hidden = false;
          var label = next.querySelector('[data-guide-evening-label]');
          if (label) label.textContent = 'Continue anyway';
          return;
        }
      }
      if (next.hasAttribute('data-guide-start')) {
        track('start');
        /* Compromiso progresivo: el primer clic lleva a la primera pregunta, sin pantallas de explicación delante */
        var firstQ = screenIndex('m1');
        if (firstQ !== -1) { show(firstQ, true); return; }
      }
      var screenNow = screens[state.i];
      if (screenNow) {
        var id = screenNow.getAttribute('data-screen');
        if (id === 'm4') track('phase1_complete');
        if (id === 'avs') track('phase2_complete');
        if (id === 'vs') track('phase3_complete');
        if (id === 'day') track('phase4_complete');
        if (id === 'daily') { track('phase5_complete'); track('completed'); startOffer(); }
      }
      show(state.i + 1, true);
      return;
    }
    if (back) {
      show(state.i - 1, true);
    }
  });

  /* ---------- Reset Card como imagen (canvas, sin dependencias) ---------- */
  function saveCardImage() {
    var W = 1080;
    var H = 1350;
    var PAD = 96;
    var canvas = document.createElement('canvas');
    canvas.width = W;
    canvas.height = H;
    var ctx = canvas.getContext('2d');

    function val(key) { return (state.a[key] || '').trim(); }

    /* Envuelve texto; devuelve la nueva Y. maxLines con elipsis. */
    function wrap(text, x, y, maxW, lineH, font, color, maxLines) {
      ctx.font = font;
      ctx.fillStyle = color;
      var words = text.split(/\s+/);
      var line = '';
      var lines = 0;
      for (var i = 0; i < words.length; i++) {
        var test = line === '' ? words[i] : line + ' ' + words[i];
        if (ctx.measureText(test).width > maxW && line !== '') {
          lines++;
          if (maxLines && lines >= maxLines && i < words.length) {
            while (ctx.measureText(line + '…').width > maxW && line.length > 1) {
              line = line.slice(0, -1);
            }
            ctx.fillText(line + '…', x, y);
            return y + lineH;
          }
          ctx.fillText(line, x, y);
          y += lineH;
          line = words[i];
        } else {
          line = test;
        }
      }
      if (line !== '') {
        ctx.fillText(line, x, y);
        y += lineH;
      }
      return y;
    }

    function label(text, y) {
      ctx.font = '600 23px "Instrument Sans", sans-serif';
      ctx.fillStyle = 'rgba(255,255,255,0.45)';
      var spaced = text.split('').join(String.fromCharCode(8202));
      ctx.fillText(spaced.toUpperCase(), PAD, y);
      return y + 44;
    }

    function draw(logoImg) {
      /* Fondo tinta + aura azul */
      ctx.fillStyle = '#0A0A0A';
      ctx.fillRect(0, 0, W, H);
      var aura = ctx.createRadialGradient(W - 140, 60, 0, W - 140, 60, 620);
      aura.addColorStop(0, 'rgba(59,102,224,0.30)');
      aura.addColorStop(1, 'rgba(59,102,224,0)');
      ctx.fillStyle = aura;
      ctx.fillRect(0, 0, W, H);

      /* Cabecera: logo + fecha */
      if (logoImg) {
        var lh = 44;
        var lw = logoImg.width * (lh / logoImg.height);
        ctx.drawImage(logoImg, PAD, 78, lw, lh);
      } else {
        ctx.font = '700 44px "Space Grotesk", sans-serif';
        ctx.fillStyle = '#FFFFFF';
        ctx.fillText('stoicindex', PAD, 112);
      }
      ctx.font = '26px "Instrument Sans", sans-serif';
      ctx.fillStyle = 'rgba(255,255,255,0.5)';
      var dateText = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
      ctx.textAlign = 'right';
      ctx.fillText(dateText, W - PAD, 112);
      ctx.textAlign = 'left';

      var y = 212;
      var maxW = W - PAD * 2;

      if (val('enemy')) {
        y = label('The enemy', y);
        y = wrap(val('enemy'), PAD, y, maxW, 52, '600 42px "Space Grotesk", sans-serif', '#FFFFFF', 2);
        y += 40;
      }
      y = label('I refuse', y);
      y = wrap(val('avs') || '…', PAD, y, maxW, 56, 'italic 42px "Newsreader", Georgia, serif', '#FFFFFF', 4) + 40;
      y = label("I'm building", y);
      y = wrap(val('vs') || '…', PAD, y, maxW, 56, 'italic 42px "Newsreader", Georgia, serif', '#3B66E0', 4) + 40;
      if (val('year')) {
        y = label('In one year', y);
        y = wrap(val('year'), PAD, y, maxW, 42, '30px "Instrument Sans", sans-serif', 'rgba(255,255,255,0.9)', 3) + 32;
      }
      if (val('month')) {
        y = label('In 30 days', y);
        y = wrap(val('month'), PAD, y, maxW, 42, '30px "Instrument Sans", sans-serif', 'rgba(255,255,255,0.9)', 3) + 32;
      }
      var levers = [];
      ['1', '2', '3'].forEach(function (n) {
        if (val('l' + n + 'a')) {
          levers.push((val('l' + n + 't') ? val('l' + n + 't') + '  ·  ' : '') + val('l' + n + 'a'));
        }
      });
      if (levers.length) {
        y = label('Every day', y);
        levers.forEach(function (row) {
          y = wrap(row, PAD, y, maxW, 42, '30px "Instrument Sans", sans-serif', 'rgba(255,255,255,0.9)', 1) + 6;
        });
      }

      /* Pie */
      ctx.strokeStyle = 'rgba(255,255,255,0.14)';
      ctx.lineWidth = 1.5;
      ctx.beginPath();
      ctx.moveTo(PAD, H - 128);
      ctx.lineTo(W - PAD, H - 128);
      ctx.stroke();
      ctx.font = 'italic 28px "Newsreader", Georgia, serif';
      ctx.fillStyle = 'rgba(255,255,255,0.55)';
      ctx.fillText('If nothing changes, nothing changes.', PAD, H - 72);
      ctx.font = '26px "Instrument Sans", sans-serif';
      ctx.fillStyle = 'rgba(255,255,255,0.4)';
      ctx.textAlign = 'right';
      ctx.fillText('stoicindex.com', W - PAD, H - 72);
      ctx.textAlign = 'left';
    }

    function download() {
      canvas.toBlob(function (blob) {
        if (!blob) return;
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'stoicindex-reset-card.png';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
        track('card_saved');
      }, 'image/png');
    }

    function render(logoImg) {
      try {
        draw(logoImg);
        download();
      } catch (err) {
        /* Canvas contaminado por el logo (CORS): reintentar con wordmark de texto */
        if (logoImg) {
          canvas.width = W; /* limpia el canvas */
          render(null);
        }
      }
    }

    var ready = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    ready.then(function () {
      var logoUrl = root.getAttribute('data-logo');
      if (logoUrl) {
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () { render(img); };
        img.onerror = function () { render(null); };
        img.src = logoUrl;
      } else {
        render(null);
      }
    });
  }

  /* ---------- .ics de recordatorios ---------- */
  function downloadICS() {
    var prompts = [
      { h: 11, m: 0, q: 'What am I avoiding right now?' },
      { h: 13, m: 30, q: 'If someone filmed the last two hours, what would they say I want most?' },
      { h: 15, m: 15, q: 'Am I moving toward the life I hate or the life I want?' },
      { h: 17, m: 0, q: "What's the most important thing I'm pretending isn't important?" },
      { h: 19, m: 30, q: 'What did I do today just to protect my old identity?' },
      { h: 21, m: 0, q: 'When did I feel most alive today? And most dead?' }
    ];
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function fmt(d) {
      return d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()) + 'T' + pad(d.getHours()) + pad(d.getMinutes()) + '00';
    }
    var now = new Date();
    var lines = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//StoicIndex//1-Day Reset//EN',
      'CALSCALE:GREGORIAN'
    ];
    prompts.forEach(function (p, idx) {
      var start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), p.h, p.m, 0);
      if (start <= now) start.setDate(start.getDate() + 1); /* hora pasada → mañana */
      var end = new Date(start.getTime() + 10 * 60000);
      lines.push(
        'BEGIN:VEVENT',
        'UID:stoic-reset-' + Date.now() + '-' + idx + '@stoicindex.com',
        'DTSTAMP:' + fmt(now),
        'DTSTART:' + fmt(start),
        'DTEND:' + fmt(end),
        'SUMMARY:' + p.q.replace(/,/g, '\\,'),
        'DESCRIPTION:StoicIndex 1-Day Reset check-in. Answer in one line at stoicindex.com/pages/reset',
        'BEGIN:VALARM',
        'TRIGGER:PT0M',
        'ACTION:DISPLAY',
        'DESCRIPTION:' + p.q.replace(/,/g, '\\,'),
        'END:VALARM',
        'END:VEVENT'
      );
    });
    lines.push('END:VCALENDAR');
    var blob = new Blob([lines.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = 'stoicindex-reset-checkins.ics';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
  }

  /* ---------- Arranque ---------- */
  function hasAnswers() {
    return Object.keys(state.a).some(function (k) {
      var v = state.a[k];
      return typeof v === 'string' ? v.trim() !== '' : v === true;
    });
  }

  function updateStartLabel() {
    var note = root.querySelector('[data-guide-resume-note]');
    var resuming = state.i > 0 || hasAnswers();
    root.querySelectorAll('[data-guide-start-label]').forEach(function (label) {
      label.textContent = resuming ? 'Continue where I left off' : 'Start with one question';
    });
    root.querySelectorAll('[data-guide-start-sub]').forEach(function (sub) { sub.hidden = resuming; });
    if (note) note.hidden = !resuming;
  }

  /* Marca de origen del formulario de email (por si return_to no conserva ?from=) */
  var FROM_KEY = 'stoic-reset-email-from';
  root.addEventListener('submit', function (e) {
    var form = e.target.closest('form');
    if (!form) return;
    var marker = form.closest('[data-guide-savepoint]') ? 'save' :
      form.closest('[data-guide-landing-mail]') ? 'landing' :
      form.closest('[data-guide-inapp-mail]') ? 'inapp' : '';
    if (marker) {
      try { localStorage.setItem(FROM_KEY, marker); } catch (err) { /* sin almacenamiento */ }
    }
  });

  function screenIndex(name) {
    for (var s = 0; s < screens.length; s++) {
      if (screens[s].getAttribute('data-screen') === name) return s;
    }
    return -1;
  }

  /* Si un formulario de email acaba de enviarse, Shopify recarga la página:
     volvemos al punto correcto según desde dónde se envió. */
  var posted = root.querySelector('[data-guide-posted]') !== null ||
    /customer_posted=true/.test(window.location.search);
  var postedFrom = (window.location.search.match(/[?&]from=([a-z]+)/) || [])[1] || '';
  if (posted && !postedFrom) {
    try { postedFrom = localStorage.getItem(FROM_KEY) || ''; } catch (err) { /* sin almacenamiento */ }
  }
  try { localStorage.removeItem(FROM_KEY); } catch (err) { /* sin almacenamiento */ }

  var startIndex = state.i;
  if (posted && postedFrom === 'save') {
    /* Envío desde el checkpoint: éxito inline y se sigue por donde iban */
    var savepoint = root.querySelector('[data-guide-savepoint]');
    var saveSuccess = root.querySelector('[data-guide-save-success]');
    if (savepoint) savepoint.hidden = true;
    if (saveSuccess) saveSuccess.hidden = false;
    var saveIdx = screenIndex('save');
    if (saveIdx !== -1) startIndex = saveIdx;
    track('email_submitted');
  } else if (posted && postedFrom === 'inapp') {
    /* Envío desde el aviso del navegador interno: portada, éxito dentro del aviso */
    var inappMail = root.querySelector('[data-guide-inapp-mail]');
    var inappSuccess = root.querySelector('[data-guide-inapp-success]');
    if (inappMail) inappMail.hidden = true;
    if (inappSuccess) inappSuccess.hidden = false;
    if (startIndex > 0) resumeTo = startIndex;
    startIndex = 0;
    track('email_submitted');
  } else if (posted && postedFrom === 'landing') {
    /* Envío desde la portada: se quedan en la portada con el mensaje de éxito */
    var landingMail = root.querySelector('[data-guide-landing-mail]');
    var mailSuccess = root.querySelector('[data-guide-mail-success]');
    var mailBox = root.querySelector('[data-guide-mailme-box]');
    if (mailBox) mailBox.hidden = false;
    if (landingMail) landingMail.hidden = true;
    if (mailSuccess) mailSuccess.hidden = false;
    if (startIndex > 0) resumeTo = startIndex;
    startIndex = 0;
    track('email_submitted');
  } else if (posted) {
    /* Envío desde la pantalla final: directo a la Reset Card (comportamiento original) */
    var cardIdx = screenIndex('card');
    if (cardIdx !== -1) startIndex = cardIdx;
    var mailBlock = root.querySelector('#StoicResetEmail');
    if (mailBlock) mailBlock.classList.add('is-posted');
    track('email_submitted');
  } else if (startIndex > 0) {
    /* Volver siempre por la landing: el botón pasa a "Continue where I left off" */
    resumeTo = startIndex;
    startIndex = 0;
  }

  /* ---------- Navegador interno de Instagram / Facebook ---------- */
  var ua = navigator.userAgent || '';
  var inApp = /Instagram|FBAN|FBAV|FB_IAB/i.test(ua);
  var inappBox = root.querySelector('[data-guide-inapp]');
  if (inApp && inappBox) {
    inappBox.hidden = false;
    var openBtn = inappBox.querySelector('[data-guide-inapp-open]');
    var howText = inappBox.querySelector('[data-guide-inapp-how]');
    var isAndroid = /Android/i.test(ua);
    var isIOS = /iPhone|iPad|iPod/i.test(ua);
    if (openBtn && isAndroid) {
      /* Android: intent a Chrome (con fallback a la misma URL) */
      openBtn.setAttribute('href', 'intent://stoicindex.com/pages/reset#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=https%3A%2F%2Fstoicindex.com%2Fpages%2Freset;end');
      openBtn.removeAttribute('target');
    }
    if (openBtn && isIOS) {
      /* iOS: Instagram no deja abrir Safari. Se intenta el esquema x-safari-https (iOS 17+); si en
         un segundo seguimos aquí, el botón se convierte en instrucción y el foco va al email. */
      openBtn.setAttribute('href', 'x-safari-https://stoicindex.com/pages/reset');
      openBtn.removeAttribute('target');
    }
    if (howText) {
      howText.textContent = isAndroid
        ? 'If nothing opens: tap the ⋮ menu, top right, then "Open in Chrome".'
        : 'Or tap the ⋯ menu, top right, then "Open in external browser".';
    }
    /* La ilustracion de su plataforma (los iconos valen en cualquier idioma del telefono) */
    var figIOS = inappBox.querySelector('[data-guide-inapp-fig-ios]');
    var figAnd = inappBox.querySelector('[data-guide-inapp-fig-android]');
    if (figIOS) figIOS.hidden = isAndroid;
    if (figAnd) figAnd.hidden = !isAndroid;
    if (openBtn) {
      openBtn.addEventListener('click', function () {
        track('inapp_open_browser');
        if (!isIOS) return;
        setTimeout(function () {
          if (document.visibilityState === 'hidden') return; /* Safari se abrió */
          openBtn.hidden = true;
          if (howText) {
            howText.textContent = 'Instagram won’t let this page open Safari. Tap the ⋯ menu, top right, then "Open in external browser". Or email yourself the link:';
            howText.classList.add('stoic-guide__inapp-how--strong');
          }
          var mail = inappBox.querySelector('input[type="email"]');
          if (mail) mail.focus({ preventScroll: false });
          track('inapp_open_blocked');
        }, 1200);
      });
    }
    track('inapp_view');
  }

  /* "Not today? Email me the link": lleva al bloque de captura de la portada */
  var mailmeBtn = root.querySelector('[data-guide-mailme]');
  var mailmeBox = root.querySelector('[data-guide-mailme-box]');
  if (mailmeBtn && mailmeBox) {
    mailmeBtn.addEventListener('click', function () {
      var open = mailmeBox.hidden;
      mailmeBox.hidden = !open;
      mailmeBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var input = mailmeBox.querySelector('input[type="email"]');
        if (input) setTimeout(function () { input.focus({ preventScroll: false }); }, 50);
        track('mailme_click');
      }
    });
  }

  updateStartLabel();
  /* skipPersist: no machacar el punto guardado hasta que el usuario navegue */
  show(startIndex, false, true);
  /* Email dejado desde la pantalla final: aterrizar en el puente 180, no arriba de la card */
  if (posted && postedFrom !== 'save' && postedFrom !== 'landing') {
    var landBridge = root.querySelector('[data-guide-bridge]');
    if (landBridge) {
      setTimeout(function () {
        landBridge.scrollIntoView({ behavior: 'smooth', block: 'center' });
        landBridge.classList.add('is-nudged');
      }, 500);
    }
  }
  /* Volver a la card otro día: refrescar las horas que quedan del código */
  if (screens[startIndex] && screens[startIndex].getAttribute('data-screen') === 'card') {
    setInterval(function () { populateBridge(screens[startIndex]); }, 60000);
  }
  track('view');
})();
